export default __webpack_public_path__ + "static/media/5.55e38d63.png";